import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';
import 'swiper/css';

const cn = classNames.bind(styles);

const SectionFeatures = (): ReactElement => {
  const { width } = useWindowSize();

  const navigationNext = React.useRef(null);
  const navigationPrev = React.useRef(null);

  return (
    <section className={cn('features')}>
      <div className={cn('container')}>
        <div className={cn('features__title-box')}>
          <img
            className={cn('features__title-icon', 'highlight')}
            src="/images/pages/DigitalTools/CargoesFlow/icon-highlight.svg"
            alt="icon"
          />
          <h2 className={cn('features__title')}>Product features</h2>
          <img
            className={cn('features__title-icon', 'mark')}
            src="/images/pages/DigitalTools/CargoesFlow/icon-mark.svg"
            alt="icon"
          />
        </div>
        <div className={cn('features__slider-box')}>
          {width > 0 && (
            <Swiper
              modules={[Navigation, Autoplay]}
              loop={false}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              spaceBetween={50}
              slidesPerView={2}
              navigation={{
                prevEl: navigationPrev.current,
                nextEl: navigationNext.current,
              }}
              onBeforeInit={(swiper: any) => {
                swiper.params.navigation.prevEl = navigationPrev.current;
                swiper.params.navigation.nextEl = navigationNext.current;
              }}
              breakpoints={{
                375: {
                  slidesPerView: 1,
                  // spaceBetween: 50
                },
                768: {
                  slidesPerView: 2,
                  // spaceBetween: 50
                },
              }}
            >
              <SwiperSlide>
                <div className="cargoes-flow__features-slide">
                  <div className="cargoes-flow__features-slide-content">
                    <ul className="cargoes-flow__features-slide-list">
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-user.svg"
                          alt="user-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Lack of customer expectations and loss of customer trust
                        </span>
                      </li>
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-road.svg"
                          alt="road-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Navigational hazards during transit
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cargoes-flow__features-slide">
                  <div className="cargoes-flow__features-slide-content">
                    <ul className="cargoes-flow__features-slide-list">
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-users.svg"
                          alt="users-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Resource constraint during peak seasons, holidays or weekends
                        </span>
                      </li>
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-cross.svg"
                          alt="cross-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Strikes by service providers` union members
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cargoes-flow__features-slide">
                  <div className="cargoes-flow__features-slide-content">
                    <ul className="cargoes-flow__features-slide-list">
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-road.svg"
                          alt="road-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Congestion on road or at ports
                        </span>
                      </li>
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-timer.svg"
                          alt="timer-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Delay or inaccurate data from connected or partners
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cargoes-flow__features-slide">
                  <div className="cargoes-flow__features-slide-content">
                    <ul className="cargoes-flow__features-slide-list">
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-money.svg"
                          alt="money-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Increasing logistics cost for expedited shipment
                        </span>
                      </li>
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-pilot.svg"
                          alt="pilot-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Increasing risk from cargo theft and/or productquality deterioration
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cargoes-flow__features-slide">
                  <div className="cargoes-flow__features-slide-content">
                    <ul className="cargoes-flow__features-slide-list">
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-militia.svg"
                          alt="militia-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Regulatory holding such as customs inspection
                        </span>
                      </li>
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-cloud.svg"
                          alt="cloud-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>Abnormal weather conditions</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cargoes-flow__features-slide">
                  <div className="cargoes-flow__features-slide-content">
                    <ul className="cargoes-flow__features-slide-list">
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-calendar.svg"
                          alt="calendar-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Transportation disruption and service delays
                        </span>
                      </li>
                      <li className={cn('features__slide-list-item')}>
                        <img
                          className={cn('features__slide-list-item-icon')}
                          src="/images/pages/DigitalTools/CargoesFlow/icon-watches.svg"
                          alt="watches-icon"
                        />
                        <span className={cn('features__slide-list-item-text')}>
                          Long poduction cycles due to delayed availability of inbound shipment
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>

              <div className={cn('features__slider-buttons')}>
                <div ref={navigationPrev} className={cn('features__slider-button', 'prev')}>
                  <img src="/images/pages/DigitalTools/CargoesFlow/slider-arrow.svg" alt="arrow" />
                </div>
                <div ref={navigationNext} className={cn('features__slider-button', 'next')}>
                  <img src="/images/pages/DigitalTools/CargoesFlow/slider-arrow.svg" alt="arrow" />
                </div>
              </div>
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default SectionFeatures;
